export default "__VITE_ASSET__84a38468__"